/**
 * Quick Filter Bar - Horizontal filter buttons for collection pages
 *
 * Features:
 * - All buttons open the filter drawer
 * - Frame Fit, Style, Shape scroll to their respective filter section
 */

if (!customElements.get('quick-filter-bar')) {
  class QuickFilterBar extends HTMLElement {
    constructor() {
      super();
      this.scrollToFilterBtns = this.querySelectorAll('[data-scroll-to-filter]');
    }

    connectedCallback() {
      // Set up scroll-to-filter handlers
      this.scrollToFilterBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          const filterHandle = btn.dataset.scrollToFilter;
          if (filterHandle) {
            // Small delay to let drawer open first
            setTimeout(() => this.scrollToFilter(filterHandle), 300);
          }
        });
      });
    }

    scrollToFilter(filterHandle) {
      // Find the filter group in the drawer
      const filtersDrawer = document.querySelector('.filters');
      if (!filtersDrawer) return;

      // Look for filter group by label
      const filterGroups = filtersDrawer.querySelectorAll('.filter-group');
      filterGroups.forEach(group => {
        const heading = group.querySelector('.filter-group__heading__text');
        if (heading) {
          const headingText = heading.textContent.trim().toLowerCase();
          const headingHandle = headingText.replace(/\s+/g, '-');
          const targetHandle = filterHandle.toLowerCase();

          if (headingHandle === targetHandle || headingText === targetHandle.replace(/-/g, ' ')) {
            // Expand if collapsed
            const toggleTarget = group.querySelector('.toggle-target');
            if (toggleTarget && toggleTarget.classList.contains('toggle-target--hidden')) {
              const toggler = group.querySelector('[data-toggle-target]');
              if (toggler) toggler.click();
            }

            // Scroll into view
            setTimeout(() => {
              group.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
          }
        }
      });
    }
  }

  customElements.define('quick-filter-bar', QuickFilterBar);
}
